import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCog, FaBell, FaMapMarkerAlt } from 'react-icons/fa';

const Settings = () => {
  const navigate = useNavigate();

  const links = [
    {
      label: 'Notification settings',
      description: 'Manage email and push notifications',
      icon: FaBell,
      path: '/notification-settings',
    },
    {
      label: 'Addresses',
      description: 'Shipping and billing addresses',
      icon: FaMapMarkerAlt,
      path: '/addresses',
    },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-gray-900">Settings</h2>
        <p className="text-gray-600 mt-1">Preferences and account settings.</p>
      </div>

      <div className="space-y-3">
        {links.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className="w-full flex items-center gap-4 p-4 bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md hover:border-gray-200 transition-all text-left"
            >
              <div className="p-3 bg-gray-100 rounded-lg">
                <Icon className="text-lg text-gray-600" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-gray-900">{item.label}</p>
                <p className="text-sm text-gray-600">{item.description}</p>
              </div>
              <span className="text-gray-400">→</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Settings;
